import { createSelector, props } from "@ngrx/store";
import { label } from "aws-amplify";
import { FrameLabel } from "src/app/models/frame_label";
import { AppState } from "../state/app.state";

const getFrameLabels = (state: AppState) => state.frameLabels;

export const selectFrameLabels = createSelector(
  getFrameLabels,
  (labels: FrameLabel[]) => Object.values(labels)
)

export const selectLabelsForFrame = createSelector(
  selectFrameLabels,
  (labels : FrameLabel[], props: { frameID : number }) =>
    labels.filter(l => l.frame === props.frameID)
)
